import React, {
    useState,
    useEffect,
} from "react"
import { PieDonutChart } from './ot'

const BaseChart4 = ({
    showComponent = [
        "PieDonutChart",
    ],
    basePieDonutChart = {
        title: "建立方式",
        chartData: [
            { source: "manual", count: 28 },
            { source: "system", count: 45 },
            { source: "ai", count: 17 },
        ],
        chartConfig: {
            manual: { label: "手動建立", color: "hsl(var(--chart-1))" },
            system: { label: "系統範本", color: "hsl(var(--chart-2))" },
            ai: { label: "智慧生成", color: "hsl(var(--chart-3))" },
        },
        xDataKeyArr: ["source"],
        yDataKeyArr: ["count"]
    },
}, ref) => {
    return (
        <>
            {
                showComponent.includes("PieDonutChart") && (
                    <PieDonutChart {...basePieDonutChart} />
                )
            }
        </>
    )
}

export default BaseChart4
